// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__tKops","header":"About_header__RfTqq","goBack":"About_goBack__Brsnk","container":"About_container__Oc-Iv"};